'use client'

import { useEffect, useState } from 'react'

import { ProductVariantSection } from './product-variant-section'
import { useSearchParams } from 'next/navigation'

const CATEGORIES = {
  iSEKK: 'iSEKK',
  CONTAINER: 'Container',
} as const

export const ProductListing = ({ products, isCompany = false }: { products: any; isCompany?: boolean }) => {
  const searchParams = useSearchParams()
  const product = searchParams?.get('product')
  const selected = searchParams?.get('selected') ?? (product?.startsWith('container') ? 'container' : 'isekk')

  const category = (
    selected && (CATEGORIES as any)[selected.toUpperCase()] ? selected : CATEGORIES.iSEKK
  ) as (typeof CATEGORIES)[keyof typeof CATEGORIES]

  const [selectedCategory, setSelectedCategory] = useState(category)
  const [shouldShowProductVariants, setShouldShowProductVariants] = useState(false)

  const handleCategorySelection = (category: any) => {
    // Only reset product variants when switching to a different category
    if (selectedCategory !== category) {
      setShouldShowProductVariants(false)
    }
    setSelectedCategory(category)
  }

  const handleSizeSelection = () => {
    setShouldShowProductVariants(true)
  }

  const isBag = (item: any) => item.name.toLowerCase().includes('sekk')
  const isContainer = (item: any) => item.name.toLowerCase().includes('container')

  useEffect(() => {
    handleCategorySelection(selected)
  }, [selected])

  return (
    <div>
      {!isCompany && (
        <div className="flex items-baseline gap-[10px]">
          <CategorySelector
            data-testid="isekk-category-selector"
            category={CATEGORIES.iSEKK}
            isSelectedCategory={selectedCategory.toLowerCase() === CATEGORIES.iSEKK.toLowerCase()}
            handleCategorySelection={handleCategorySelection}
          />
          <>
            <p className="translate-y-[-2px] text-[20px]">/</p>
            <CategorySelector
              data-testid="container-category-selector"
              category={CATEGORIES.CONTAINER}
              isSelectedCategory={selectedCategory.toLowerCase() === CATEGORIES.CONTAINER.toLowerCase()}
              handleCategorySelection={handleCategorySelection}
            />
          </>
        </div>
      )}
      <div className="h-4" />
      <ProductVariantSection
        key={selectedCategory} // Reset component state when category changes
        items={
          selectedCategory.toLowerCase() === CATEGORIES.iSEKK.toLowerCase()
            ? products?.children?.filter(isBag) || []
            : products?.children?.filter(isContainer) || []
        }
        productType={selectedCategory.toLowerCase() === CATEGORIES.iSEKK.toLowerCase() ? 'bag' : 'container'}
        handleSizeSelection={handleSizeSelection}
        shouldShowProductVariants={shouldShowProductVariants}
        isCompany={isCompany}
        initialProductPath={product}
      />
    </div>
  )
}

const CategorySelector = ({ category, isSelectedCategory, handleCategorySelection, ...rest }: any) => (
  <p
    {...rest}
    className={`cursor-pointer font-bold transition-colors duration-200 ease-out hover:text-[#666666] ${
      isSelectedCategory ? 'text-[40px] text-black' : 'text-[20px] text-[#bfbfbf]'
    }`}
    onClick={() => handleCategorySelection(category)}
  >
    {category}
  </p>
)
